import React from 'react';
import {Trans, useTranslation} from "react-i18next";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import {formatCurrency} from "../../../utils";


export default ({totalPrice, minimumPrice, handleAcceptMinimumPrice}) => {
  const [t] = useTranslation();


  console.log('Verify minimum price');
  const open = true;

  return <Dialog aria-labelledby="simple-dialog-title" open={open}>
    <DialogTitle id="simple-dialog-title">
      <Trans>Minimum price warning</Trans>
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        {t('You have placed an order for %s, while the minimum price is %s. The order price will be adjusted to this amount.',
          {postProcess: 'sprintf', sprintf: [formatCurrency(totalPrice), formatCurrency(minimumPrice)]})}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button color='primary' href='/m/'>
        <Trans>Shop more</Trans>
      </Button>
      <Button variant='contained' color='primary' onClick={handleAcceptMinimumPrice}>
        <Trans>Approve minimum price</Trans>
      </Button>
    </DialogActions>
  </Dialog>
}